/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";

import { TYPES_MANUFACTURER } from "./constants";

const ManufacturerUploadField = ({ type, onFileChange, fileList }) => {
  const inputRefs = {};
  const generateBtnId = (text) => `${text.replace(/\s/g, "-").toLowerCase()}-btn`;

  const getPlaceholder = (inputFile, type, index) => {
    const filename = fileList[type][index]["file"]?.name;
    return filename || inputFile.placeholder;
  };

  return type
    ? TYPES_MANUFACTURER[type].map((inputFile, index) => (
        <div key={inputFile.id} className="row rowStretch" style={{ flexWrap: "nowrap" }}>
          <div className="col">
            <label>
              <span>{inputFile.hint}</span>
              <input
                id={`${inputFile.id.toLowerCase()}-input`}
                data-testid={`${inputFile.id.toLowerCase()}-input`}
                type="text"
                placeholder={getPlaceholder(inputFile, type, index)}
                disabled
              />
              <input
                type="file"
                data-testid={`hidden-${inputFile.id.toLowerCase()}-input`}
                hidden
                ref={(ref) => (inputRefs[inputFile.id] = ref)}
                onChange={(e) => onFileChange(e, index)}
                accept={inputFile.format}
              />
            </label>
          </div>
          <div className="col browse-btn-area">
            <label>
              <span>&nbsp;</span>
              <button
                id={generateBtnId(inputFile.text)}
                className="btn btnTeal"
                onClick={() => inputRefs[inputFile.id].click()}
              >
                {inputFile.text}
              </button>
            </label>
          </div>
        </div>
      ))
    : null;
};

const UploadManufacturer = ({
  onUpload,
  fileList,
  isLoading,
  resetForms,
  manufacturer,
  onFileChange,
  cancelButton,
  setManufacturer,
  shouldDisableUploadBtn,
  shouldShowFileFormatError,
}) => {
  return (
    <>
      <div className="row rowStretch">
        <div className="col col-s-100 col50 colFlex0">
          <label>
            <span>Manufacturer</span>
            <select
              id="manufacturer-select"
              data-testid="manufacturer-select"
              onChange={(e) => setManufacturer(e.target.value)}
              value={manufacturer}
            >
              <option value="">Select Manufacturer...</option>
              <option value="Biotronik">Biotronik</option>
              <option value="BostonScientific">Boston Scientific</option>
              <option value="Medtronic">Medtronic</option>
              <option value="St.Jude">St. Jude</option>
            </select>
          </label>
        </div>
        <div className="col col100 col100 browse">
          <ManufacturerUploadField type={manufacturer} onFileChange={onFileChange} fileList={fileList} />
          {shouldShowFileFormatError && (
            <span className="error" data-testid="file-error-message">
              The file you are attempting to upload, is invalid. Please check the file type and try again.
            </span>
          )}
        </div>
      </div>
      <div className="row rowStretch noMargin">
        <div className="col create-ir-col" style={{ display: "flex" }}>
          <button
            id="upload-btn-modal"
            data-testid="upload-btn-modal"
            className="btn btnSuccess"
            onClick={onUpload}
            disabled={shouldDisableUploadBtn}
          >
            {isLoading ? (
              <div
                id="results-loading-icon-2"
                className="saving-white-ico icon-64"
                style={{ width: 15, height: 15, marginRight: 3 }}
              />
            ) : null}{" "}
            Upload
          </button>
          <a id="cancel-btn-modal" href="#" onClick={resetForms} ref={cancelButton}>
            <button className="btn btn-cancel">Cancel</button>
          </a>
        </div>
      </div>
    </>
  );
};

export default UploadManufacturer;
